<template>
  <div class="Cherchables">
    <h2 class="subtitle">
      Cette page regroupe tous les termes cherchables, par catégories. <br />
      Vous pouvez les visualiser, tester la recherche, et en supprimer.
    </h2>
    <hr />
    <div class="columns is-multiline">
      <div class="column is-three-quarters">
        <help-message>
          <p slot="title">Renommage et fusion de tags</p>
          <p>
            Vous pouvez maintenant renommer et/ou fusionner des tags.<br />Au
            sein d'une même catégorie, sélectionnez un ou des tags en cliquant
            sur leur nom. Ils se surlignent en vert.<br />Une boîte de dialogue
            apparaît, permettant de les rassembler en un nouveau tag, ou, dans
            le cas d'un seul tag, de le substituer par un nouveau, action
            similaire à le renommer.<br />Tous les contenus liés sont mis à
            jour.
          </p>
        </help-message>
      </div>
      <div class="column is-full" v-for="type in types" :key="type">
        <h3>Liste des {{ _(type) }}</h3>
        <div class="columns">
          <div class="column is-three-quarters">
            <div class="field">
              <kv-listor
                @select="handleSelect(type, $event)"
                :selection="selection[type]"
                :type="type"
              ></kv-listor>
            </div>
            <div class="field">
              <kv-suggestor :type="type" :item="null"></kv-suggestor>
            </div>
          </div>
          <div
            class="column is-one-quarter"
            v-show="selection[type].length > 0"
          >
            <div class="squarebox">
              <h3 v-if="selection[type].length === 1">
                Renommer le tag sélectionné
              </h3>
              <h3 v-if="selection[type].length > 1">
                Fusionner les tags sélectionnés
              </h3>
              <div class="field" style="margin-top: 16px;">
                <vertical-field>
                  <label for="" class="label" slot="label"
                    >Nom du nouveau tag :</label
                  >
                  <input type="text" class="input" v-model="newTag[type]" />
                </vertical-field>
              </div>
              <div class="field">
                <button
                  class="button"
                  :disabled="newTag[type].trim().length === 0"
                  :class="loading[type] ? 'is-loading' : ''"
                  @click="merge(type)"
                >
                  {{ selection[type].length > 1 ? "Fusionner" : "Renommer" }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import { KV_LIST_FRENCH, KV_LIST, types } from "../store/actions/kv";
import KvListor from "../components/Form/KvListor";
import KvSuggestor from "../components/Form/KvSuggestor";
import VerticalField from "../components/Form/VerticalField";
import { kvChangeKey } from "../store/models/_helpers";
import HelpMessage from "../components/Form/HelpMessage";

const makeList = fn =>
  KV_LIST.reduce((acc, name) => {
    acc[name] = fn();
    return acc;
  }, {});

export default {
  name: "Cherchables",
  components: { HelpMessage, VerticalField, KvSuggestor, KvListor },
  data() {
    return {
      types: KV_LIST,
      selection: makeList(() => []),
      newTag: makeList(() => ""),
      loading: makeList(() => false)
    };
  },
  methods: {
    handleSelect(type, event) {
      console.log(type);
      const i = this.selection[type].indexOf(event);
      if (i !== -1) {
        this.selection[type].splice(i, 1);
      } else {
        this.selection[type].push(event);
      }
    },
    async merge(type) {
      this.loading[type] = true;
      await this.$store.dispatch(types.MERGE_KV, {
        type,
        ids: this.selection[type],
        replacement: this.newTag[type]
      });
      this.loading[type] = false;
      this.newTag[type] = "";
      this.selection[type] = [];
      this.$root.$emit(kvChangeKey(type));
    },
    _(k) {
      return KV_LIST_FRENCH[k];
    }
  }
};
</script>

<style lang="scss">
.Cherchables {
}
</style>
